/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'shared';
const componentName = 'item-preview-defaults';
const prefix = `${moduleName}.${componentName}`;

export const tenantLabel = `${prefix}.tenantLabel`;
export const lastModifiedLabel = `${prefix}.lastModifiedLabel`;

export const ENGLISH = {
    [tenantLabel]: 'Tenant',
    [lastModifiedLabel]: 'Last Modified',
};
